import { Component, OnInit, OnDestroy } from '@angular/core';
import { HomeService } from '../services/home.service';
import { ConfigService } from '../services/config.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-margin',
  templateUrl: './margin.component.html',
  styleUrls: ['./margin.component.scss']
})
export class MarginComponent implements OnInit, OnDestroy {
  // Initialize margin with default values to prevent undefined errors
  margin: any = {
    total: 0,
    distributed: 0,
    available: 0,
    fixed: 0,
    credit: 0,
    free: 0,
    silver_total: 0,
    silver_distributed: 0,
    silver_available: 0,
    silver_fixed: 0,
    silver_credit: 0,
    silver_free: 0
  };
  
  isGold: boolean = true;
  goldSilverMargin: any = {
    headColor: '#000000',
    labels: '#666666',
    mySelectGoldBackground: '#ffffff',
    mySelectGoldColor: '#000000'
  };
  
  private destroy$ = new Subject<void>();

  constructor(
    private home: HomeService,
    private configService: ConfigService
  ) {}

  ngOnInit(): void {
    this.loadConfig();
    this.marginGet(); // Load gold margin by default
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Load configuration
   */
  loadConfig(): void {
    const config = this.configService.getConfig();
    if (config?.goldSilverMargin) {
      this.goldSilverMargin = {
        ...this.goldSilverMargin,
        ...config.goldSilverMargin
      };
    }
  }

  /**
   * Get gold margin
   */
  marginGet(): void {
    this.home.getMargin()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          if (res?.success && res?.data) {
            // Merge with existing margin to preserve silver fields
            this.margin = {
              ...this.margin,
              ...res.data
            };
          } else if (res?.data) {
            this.margin = {
              ...this.margin,
              ...res.data
            };
          }
          this.isGold = true;
        },
        error: (err) => {
          console.error('Error loading gold margin:', err);
          // Keep existing values on error
        }
      });
  }

  /**
   * Get silver margin
   */
  marginSilverGet(): void {
    this.home.silverGetMargin()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          if (res?.success && res?.data) {
            // Merge with existing margin to preserve gold fields
            this.margin = {
              ...this.margin,
              ...res.data
            };
          } else if (res?.data) {
            this.margin = {
              ...this.margin,
              ...res.data
            };
          }
          this.isGold = false;
        },
        error: (err) => {
          console.error('Error loading silver margin:', err);
          // Keep existing values on error
        }
      });
  }

  /**
   * Handle gold/silver selection change
   */
  goldSelect(event: any): void {
    const value = event?.target?.value;
    if (value === 'Gold') {
      this.marginGet();
    } else if (value === 'Silver') {
      this.marginSilverGet();
    }
  }
}